import React, { memo, useEffect, useState } from "react";
import { ICommercialsMenuItemProps, CommericalAction } from "../../../types";
import { useCommercialMenusContext } from "../../../contexts/commercial-context";
import { CommercialMenu } from "./commercial-menu";
import { Checkbox } from "@mui/material";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const RightFooterWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CheckboxLabel = styled.div`
  width: 100%;
  text-align: right;
  color: ${(props) => props.theme.textColor};
  font-size: 11px;
  line-height: 12px;
  padding-right: 4px;
`;

const ForAllGuestsMenuItem = (props: ICommercialsMenuItemProps) => {
  const { t } = useTranslation();
  const [action, setAction] = useState<CommericalAction | null>(null);
  const { menusAvailabilities, performAction, selectedMenusIds } =
    useCommercialMenusContext();

  const onCheck = (ev: any, checked: boolean) => {
    props.setChildLoading(true);
    setAction(checked ? CommericalAction.add : CommericalAction.remove);
  };
  const [isSelected, setIsSelected] = useState<boolean>(false);
  useEffect(() => {
    setIsSelected(selectedMenusIds.includes(props.menu.id));
  }, [selectedMenusIds]);

  useEffect(() => {
    if (action) {
      performAction(action, { [props.menu.id]: undefined });
    }
  }, [action]);
  const canInteract =
    menusAvailabilities[props.menu.id] &&
    (props.menu.available_for_pending_booking ?? true);
  return (
    <CommercialMenu
      menu={props.menu}
      canInteract={canInteract}
      rightFooter={
        <RightFooterWrapper>
          <CheckboxLabel data-test="label">
            {t("instabook.menus.for_all_guests")}
          </CheckboxLabel>
          <Checkbox
            disabled={!canInteract}
            data-test={`menu-check-${props.menu.id}`}
            checked={isSelected}
            onChange={onCheck}
            size="small"
          />
        </RightFooterWrapper>
      }
    />
  );
};

export const CommercialsForAllGuestsMenuItem = memo(ForAllGuestsMenuItem);
